module.exports = __webpack_public_path__ + "d9cd94df038a167a3c509d1bcaefce78.png"


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/modules/header/components/images/umax-logo.png
 ** module id = 1469
 ** module chunks = 0
 **/